/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserRoleResponseModel } from '../../models/user-role-response-model';

export interface GetRoleById$Params {
  userId: string;
  roleName: 'PRODUCT_ADMIN' | 'PRICING_ADMIN' | 'MERCHANT_ADMIN' | 'COMMERCIAL_ADMIN' | 'EXCISE_MANAGER' | 'SUBSCRIPTION_ADMIN' | 'SETTINGS_ADMIN' | 'USER_ADMIN' | 'SUPPLY_MANAGER' | 'EASYLOT_ADMIN' | 'TELESALES' | 'TECHNICAL_USER' | 'IMPERSONATION' | 'PRICE_SYNC_ADMIN' | 'PRICE_SYNC' | 'PRODUCT_SYNC' | 'STOCK_SYNC' | 'PRODUCT_MAPPING_REQUEST_ADMIN';
}

export function getRoleById(http: HttpClient, rootUrl: string, params: GetRoleById$Params, context?: HttpContext): Observable<StrictHttpResponse<UserRoleResponseModel>> {
  const rb = new RequestBuilder(rootUrl, getRoleById.PATH, 'get');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.path('roleName', params.roleName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserRoleResponseModel>;
    })
  );
}

getRoleById.PATH = '/users/{userId}/roles/{roleName}';
